import React, { useEffect, useState } from 'react'
import Lottie from 'react-lottie-player'

import cx from 'classnames'
import ModalPortal from 'ModalPortal'

import { YANADOO_CDN_HOST } from 'common/config'

import s from './ModalAiTravel.module.scss'
const defaultOptions = {
  loop: true,
  play: true,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice'
  }
}

export default function ModalFeedbackLoading() {
  const [lottieData, setLottieData] = useState(null)

  useEffect(() => {
    const fetchLottieData = async () => {
      try {
        const response = await fetch(`${YANADOO_CDN_HOST}/lottie/aitravel-loading-feedback.json`)
        const jsonData = await response.json()
        setLottieData(jsonData)
      } catch (error) {
        console.error('Lottie 데이터를 불러오는데 실패했습니다:', error)
      }
    }
    fetchLottieData()
  }, [])

  return (
    <ModalPortal>
      <div className={cx(s.modalAiTravel, s.feedbackLoading)}>
        <div className={s.loadingContent}>
          <figure className={s.loadingImg}>
            <Lottie {...defaultOptions} animationData={lottieData} />
          </figure>
          <dl className={s.loadingTxt}>
            <dt>피드백 작성중...</dt>
            <dd>
              AI가 피드백 내용을 정리하고 있어요.
              <br />
              잠시만 기다려 주세요!
            </dd>
          </dl>
        </div>
      </div>
    </ModalPortal>
  )
}
